import React from "react";
import { UserAuth } from '../../context/AuthContext'
import { FaUserAstronaut } from 'react-icons/fa';
import { IoMdWallet } from 'react-icons/io';
import { MdAddTask, MdHistory } from 'react-icons/md';
import { BiUserVoice, BiStreetView, BiWallet, BiStar } from 'react-icons/bi';
import { RiVipCrown2Fill } from 'react-icons/ri';
import { VscSignOut } from 'react-icons/vsc'
import { RxRocket } from 'react-icons/rx';
import { NavLink, useLocation } from 'react-router-dom';



const Header = () => {

    const { user } = UserAuth();
  
    const uname = user.displayName;

    /* Header 1*/
    // lama const header = [
        // { title: 'Pasukan', to: '', icon: <FaUserAstronaut size='20' /> },
        // { title: 'Wallet List', to: '/myWalletList', icon: <IoMdWallet size='20' /> },
        // { title: 'Add Aidrop', to: '/airdrop/new', icon: <MdOutlinePlaylistAdd size='20' /> },
        // { title: 'Garap Aidrop', to: '/airdrop/do', icon: <MdAddTask size='20' /> },
    // ]
    
    const header = [
        { title: 'Pasukan', to: '/pasukan/view', icon: <FaUserAstronaut size='20' /> },
        { title: 'Wallet List', to: '/myWalletList', icon: <IoMdWallet size='20' /> },
        { title: 'Garap Aidrop', to: '/airdrop/do', icon: <MdAddTask size='20' /> },
        { title: 'Upgrade', to: '/upgrade', icon: <RiVipCrown2Fill size='20' /> }
    ]

    const headerMobile = [
        { title: 'Tambah Pasukan', to: '/pasukan/add', bgicon: 'bg-orange-50', icon: <BiUserVoice size='24px' className="fill-orange-400" /> },
        { title: 'Lihat Pasukan', to: '/pasukan/view', bgicon: 'bg-pink-50', icon: <BiStreetView size='24px' className="fill-pink-400" /> },
        { title: 'Wallet List', to: '/myWalletList', bgicon: 'bg-rose-50', icon: <BiWallet size='24px' className="fill-rose-600" /> },
        //{ title: 'Add Aidrop', to: '/airdrop/add', bgicon: 'bg-cyan-50', icon: <GiSmallFire size='24px' className="text-primary" /> },
        { title: 'Garap Aidrop', to: '/airdrop/do', bgicon: 'bg-cyan-50', icon: <RxRocket size='24px' className="text-primary" /> },
    ]

    /* Render Header 1 */
    const headerSatu = header.map((hasil, i) =>
        <NavLink key={i} to={hasil.to} className='hover:underline'>
            <div className='flex py-4 px-4 items-center'>
                <span className='mr-2'>{hasil.icon}</span>
                <span>{hasil.title}</span>
            </div>
        </NavLink>
    );

    const bego = (id) => {
        return 'h-[44px] w-[44px] rounded-full ' + id;
    }

    const location = useLocation();
    const isHomePage = location.pathname === "/";

    const headerDua = headerMobile.map((hasil, i) =>
        <NavLink key={i} to={hasil.to} exact={true}>
            <div className='w-[64px] flex flex-col items-center'>
                <div className={bego(hasil.bgicon)}>
                    <span className='w-full h-full flex items-center justify-center'>
                        {hasil.icon}
                    </span>
                </div>
                <div className={`text-xs mt-2 text-center ${location.pathname === hasil.to ? 'text-primary font-bold' : 'text-zinc-800 hover:font-semibold'} `}>{hasil.title}</div>
            </div>
        </NavLink>
    );

    return (
        <div className='pt-[44px] md:pt-11'>
            <div className='hidden md:flex bg-gradient-to-r from-biru1 to-blue-600 justify-start items-center text-white font-semibold'>
                {headerSatu}
            </div>
            {isHomePage && (
                <div>
                    <div className="md:hidden block bg-gradient-to-r from-primary to-blue-700 h-10 rounded-b-xl">
                    </div>
                    <div className='md:hidden block -mt-8 px-4'>
                        <div className=' bg-white rounded-t-md  pt-2 border border-b-0 border-slate-200'>
                            <div className="flex justify-between items-center">
                                <div className="px-4">
                                    <h1 className='text-xs font-normal'>
                                        Selamat datang 👋, {uname}</h1>
                                </div>
                                <div className="text-xs font-bold rounded-l-md bg-gradient-to-r from-cyan-300 to-primary px-2 py-1 text-white">
                                    Lihat Panduan untuk Memulai
                                </div>
                            </div>
                        </div>
                        <div className="rounded-b-md bg-white border border-t-0 border-slate-200">
                            <div className="px-4 py-3 flex justify-between items-center">
                                <div className="flex flex-col pl-1 border-l border-slate-100">
                                    <div className="flex justify-start items-center">
                                        <VscSignOut size="16px" className="text-primary mr-1" /> <span className="text-slate-600 text-xs font-normal">User Tier</span>
                                    </div>
                                    <div className="text-sm font-semibold text-zinc-800">
                                        Free User
                                    </div>
                                    <div className="text-xs font-bold text-sky-700">
                                        Upgrade
                                    </div>
                                </div>
                                <div className="flex flex-col pl-1 border-l border-slate-100">
                                    <div className="flex justify-start items-center">
                                        <BiStar size="16px" className="text-primary mr-1" /> <span className="text-slate-600 text-xs font-normal">Rewards</span>
                                    </div>
                                    <div className="text-sm font-semibold text-zinc-800">
                                        Klaim Bonus
                                    </div>
                                    <div className="text-xs font-normal text-slate-600">
                                        100% Gratis
                                    </div>
                                </div>
                                <div className="flex flex-col pl-1 border-l border-slate-100">
                                    <div className="flex justify-start items-center">
                                        <MdHistory size="16px" className="text-primary mr-1" /> <span className="text-slate-600 text-xs font-normal">Masa Aktif</span>
                                    </div>
                                    <div className="text-sm font-semibold text-zinc-800">
                                        31 Des 2022
                                    </div>
                                    <div className="text-xs font-bold text-sky-700">
                                        Perpanjang
                                    </div>
                                </div>
                            </div>
                            <div className="bottom-0 rounded-b-md bg-gradient-to-r from-primary to-blue-600 h-[3px]"></div>
                        </div>
                    </div>
                </div>
            )}
            <div className="md:hidden px-4 py-6 bg-white">
                <div className="px-2 grid grid-cols-4 justify-items-center">
                    {headerDua}
                </div>
            </div>
        </div>
    )
}

export default Header
